module.exports = __webpack_public_path__ + "static/media/sf_400.589e2c8ecab2e04e8b281b6336cdaee5.png";